<template>
  <div id="segmentManage">
    <el-row>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>系统管理</el-breadcrumb-item>
        <el-breadcrumb-item>切面管理</el-breadcrumb-item>
      </el-breadcrumb>
      <el-divider></el-divider>
    </el-row>
    <el-row class="buttons">
      <el-col align="left">
        <el-button type="primary" @click="openCreateSegmentDialog">新增</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-table :data="tableData" style="width: 100%" :header-cell-style="headerCellStyle">
        <el-table-column type="index" width="50" />
        <el-table-column prop="name" label="切面名称">
        </el-table-column>
        <el-table-column prop="project_name" label="路段名称">
        </el-table-column>
        <el-table-column prop="description" label="项目名称">
        </el-table-column>
        <el-table-column prop="longlat" label="经纬度">
        </el-table-column>
        <el-table-column prop="created_at" label="创建时间">
          <template slot-scope="scope">
            {{ moment(scope.row.created_at).format('YYYY-MM-DD HH:mm:ss') }}
          </template>
        </el-table-column>
        <el-table-column prop="user_id" label="操作" width="300px">
          <template slot-scope="scope">
            <el-button type="text" @click="openUpdateSegmentDialog(scope.row)">修改</el-button>
            <el-button type="text" @click="openSensorDialog(scope.row)">传感器</el-button>
            <el-popconfirm style="margin-left: 10px;" :title="'确定删除：' + scope.row.name + ' 吗？'"
              @confirm="deleteSegment(scope.row.segment_id)">
              <el-button slot="reference" type="text">删除</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination class="pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="pageIndex" :page-sizes="[5, 10, 20]" :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
      </el-pagination>
    </el-row>
    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible">
      <el-form :inline="true" :rules="rules" :model="form" ref="form" align="left" label-width="100px">
        <el-form-item align="left" label="项目名" prop="user_id" :rules="[{ required: true, message: '项目名不能为空' }]">
          <el-select v-model="form.user_id" filterable placeholder="请选择" @change="onSelectUser">
            <el-option v-for="item in allUsers" :key="item.user_id" :label="item.description" :value="item.user_id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item align="left" label="路段名" prop="project_id"
          :rules="[{ required: true, message: '路段名不能为空', trigger: 'blur' }]">
          <el-select v-model="form.project_id" filterable placeholder="请选择">
            <el-option v-for="item in projects" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="切面名称" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="切面经纬度" prop="longlat">
          <el-input v-model="form.longlat">
            <el-button slot="append" @click="openBaiduGetPoint">拾取</el-button>
          </el-input>
        </el-form-item>
        <p></p>
        <el-form-item label="使用地形图">
          <el-checkbox v-model="form.use_photo" :true-label="true" :false-label="false"></el-checkbox>
        </el-form-item>
        <el-form-item label="地形图片" prop="image_url" v-if="form.use_photo">
          <el-upload class="avatar-uploader" action="/api/upload" :show-file-list="false"
            :on-success="handleImageSuccess" :before-upload="beforeImageUpload">
            <img v-if="form.image_url" :src="form.image_url" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <p></p>
        <el-form-item label="左上经纬度" prop="image_top_left_longlat"  v-if="form.use_photo">
          <el-input v-model="form.image_top_left_longlat">
            <el-button slot="append" @click="openBaiduGetPoint">拾取</el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="右下经纬度" prop="image_bottom_right_longlat"  v-if="form.use_photo">
          <el-input v-model="form.image_bottom_right_longlat">
            <el-button slot="append" @click="openBaiduGetPoint">拾取</el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="实景类型">
          <el-radio-group v-model="form.live_type">
            <el-radio label="photo">图片</el-radio>
            <el-radio label="stream">直播</el-radio>
          </el-radio-group>
        </el-form-item>
        <p v-if="form.live_type === 'photo'"></p>
        <el-form-item label="实景图片" v-if="form.live_type === 'photo'">
          <el-upload class="avatar-uploader" action="/api/upload" :show-file-list="false"
            :on-success="handlePhotoSuccess" :before-upload="beforePhotoUpload">
            <img v-if="form.live_photo_url" :src="form.live_photo_url" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <p v-if="form.live_type === 'stream'"></p>
        <el-form-item label="直播地址" style="width: 100;"  v-if="form.live_type === 'stream'">
          <el-input v-model="form.live_stream_url" style="width: 500px;"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveSegment">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="编辑传感器" :visible.sync="sensorDialogVisible" width="1200px">
      <el-form :inline="true" :rules="rules" :model="form" ref="form" align="left" label-width="100px">
        <el-form-item label="层" style="width: 100;">
          <el-input-number v-model="sensorForm.layers" :min="1" :max="maxSensorLayers" label="层"></el-input-number>
        </el-form-item>
        <el-form-item label="序列" style="width: 100;">
          <el-input-number v-model="sensorForm.sequences" :min="1" :max="maxSensorSequences" label="序列"></el-input-number>
        </el-form-item>
        <div>初始值如果不填写，则使用第一次上传的数据</div>
        <el-divider></el-divider>
        <div class="tugongdai">
          <div v-for="layer in sensorForm.layers" class="layer">
            <div class="layer-header">{{ sensorForm.layers - layer + 1 }}</div>
            <div v-for="sequence in sensorForm.sequences" class="sequence">
              <div class="sequence-row"
                :class="{ 'bound': sensorForm.sensorBindings[sensorForm.layers - layer][sequence -1], 'bound-bad': !sensorForm.sensorBindings[sensorForm.layers - layer][sequence-1].match(sensorBindingRegex) }">
                <input v-model="sensorForm.sensorBindings[sensorForm.layers - layer][sequence -1]"
                  placeholder="绑定（设备id-通道）" />
              </div>
              <!-- <div class="sequence-row">
                <input placeholder="初始值" />
              </div> -->
            </div>
          </div>
          <div class="layer footer">
            <div class="layer-header">{{ ' ' }}</div>
            <div v-for="sequence in sensorForm.sequences" class="sequence">
              {{ sequence }}
            </div>
          </div>
        </div>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="sensorDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateSensorBindings">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import api from '@/api/api'
import * as moment from 'moment';

var checkCoordinate = (rule, value, callback) => {
  if (!value) {
    // 如果没有值，视为通过验证，可根据实际需求调整为必填
    return callback();
  }

  // 经纬度格式正则表达式
  const regex = /^-?\d{1,3}\.\d+,-?\d{1,2}\.\d+$/;
  if (!regex.test(value)) {
    return callback(new Error('请输入正确的经纬度格式，如 "120.1234567,30.1234567"'));
  }

  // 分割经度和纬度
  const [longitude, latitude] = value.split(',');

  // 检查经度范围
  if (longitude < -180 || longitude > 180) {
    return callback(new Error('经度必须在 -180 到 180 之间'));
  }

  // 检查纬度范围
  if (latitude < -90 || latitude > 90) {
    return callback(new Error('纬度必须在 -90 到 90 之间'));
  }

  // 如果一切正常，则调用 callback 通过验证
  callback();
};

export default {
  name: 'segmentManage',
  components: {
  },
  data() {
    return {
      dialogTitle: '',
      dialogFormVisible: false,
      sensorDialogVisible: false,
      sensorBindingRegex: /^(\d{1,10}-[1-9][0-9]?$|^100$|^\s*)$/,
      allUsers: [],
      projects: [],
      maxSensorLayers: 10,
      maxSensorSequences: 20,
      rules: {
        name: [{ required: true, message: '切面名不能为空' }],
        longlat: [
          { required: true, message: '切面经纬度不能为空' },
          { validator: checkCoordinate, trigger: 'blur' }
        ]
      },
      form: {
        type: '',
        user_id: '',
        project_id: '',
        name: '',
        longlat: '',
        image_top_left_longlat: '', image_bottom_right_longlat: '',
        image_url: '',
        live_stream_url: '', live_photo_url: '', live_type: 'photo',
        use_photo: false
      },
      defaultForm: {
        type: '',
        user_id: '',
        project_id: '',
        name: '',
        longlat: '',
        image_top_left_longlat: '', image_bottom_right_longlat: '',
        image_url: '',
        live_stream_url: '', live_photo_url: '', live_type: 'photo'
      },
      sensorForm: {
        segment_id: null,
        layers: 1,
        sequences: 1,
        sensorBindings: [
          ['']
        ]
      },
      totalCount: 0,
      pageSize: 10,
      pageIndex: 1,
      headerCellStyle: {
        background: 'rgb(245,245,245)'
      },
      tableData: []
    }
  }, mounted() {
    const that = this;
    this.refresh();
    this.moment = moment;
    this.sensorForm.sensorBindings = Array.from({ length: this.maxSensorLayers }, () => Array.from({ length: this.maxSensorSequences }, () => ''));
  },
  methods: {
    refresh() {
      const that = this;
      api.post('/segments', { pageSize: that.pageSize, pageIndex: that.pageIndex }).then(response => {
        that.tableData = response.data.data;
        that.tableData.map(t => {
          t.longlat = t.longitude + ',' + t.latitude;
          return t;
        })
        console.log(that.tableData)
        that.totalCount = response.data.totalCount;
        console.log(that.tableData)
      })
    },
    onSelectUser() {
      const that = this;
      that.form.project_id = null;
      that.projects = [];
      api.post('/projectsByUserId', { user_id: that.form.user_id }).then(response => {
        that.projects = response.data.data;
      })
    },
    handleImageSuccess(res, file) {
      this.form.image_url = '/api/download?id=' + res.id;
    },
    handlePhotoSuccess(res, file) {
      this.form.live_photo_url = '/api/download?id=' + res.id;
    },
    beforeImageUpload(file) {
      return this.beforeAvatarUpload(file,this.handleImageSuccess);
    },
    beforePhotoUpload(file){
      return this.beforeAvatarUpload(file,this.handlePhotoSuccess);
    },
    beforeAvatarUpload(file,callback) {
      // const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
        return;
      }

        const formData = new FormData();
        formData.append('file', file);

        api.post('/upload', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(response => {
          callback(response.data.data, file);
        })
        .catch(error => {
          this.$message.error('上传失败，请重试' + error);
        });

        // 阻止默认的上传行为
        return false;
    },
    handleSizeChange(val) {
      this.pageIndex = 1;
      this.pageSize = val;
      this.refresh();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.refresh();
    },
    updateSegment(userId) {
      const that = this;
      this.$refs['form'].validate(valid => {
        if (valid) {
          api.post('/updateSegment', that.form).then(response => {
            if (response.data.success) {
              this.$message({
                message: '修改成功',
                type: 'success'
              })
              that.dialogFormVisible = false;
              that.refresh();
            } else {
              this.$message({
                message: '修改失败',
                type: 'error'
              })
            }
          })
        } else {
          return false;
        }
      })
    },
    openCreateSegmentDialog() {
      const that = this;
      that.dialogTitle = '新增切面'
      that.form = that.defaultForm;
      that.form.type = 'create';
      api.post('/users', { pageSize: 100, pageIndex: 1 }).then(response => {
        that.allUsers = response.data.data;
      })
      that.form.image_url = '';
      that.form.live_photo_url = '';
      that.dialogFormVisible = true
    },
    openUpdateSegmentDialog(row) {
      const that = this;
      api.post('/users', { pageSize: 100, pageIndex: 1 }).then(response => {
        that.allUsers = response.data.data;
      })
      that.projects = [];
      api.post('/projectsByUserId', { user_id: row.user_id }).then(response => {
        that.projects = response.data.data;
      })
      that.dialogTitle = '修改切面'
      that.dialogFormVisible = true
      that.form = row;
      that.form.type = 'update';
      that.form.longlat = row.longitude + ',' + row.latitude;
      that.form.image_top_left_longlat = row.image_top_left_longitude + ',' + row.image_top_left_latitude;
      that.form.image_bottom_right_longlat = row.image_bottom_right_longitude + ',' + row.image_bottom_right_latitude;
    },
    openSensorDialog(row) {
      const that = this;
      function transformToSensorBindings(dataArray) {
        // 确定layers和sequences的数量（即数组中最大的layer_index和sequence_index）
        let maxLayerIndex = Math.max(...dataArray.map(item => item.layer_index));
        let maxSequenceIndex = Math.max(...dataArray.map(item => item.sequence_index));
        maxLayerIndex = Math.max(maxLayerIndex,1)
        maxSequenceIndex = Math.max(maxSequenceIndex,1)

        // 创建sensorBindings数组的矩形结构，初始化为''而不是null
        const sensorBindings = new Array(that.maxSensorLayers)
          .fill(null)
          .map(() => new Array(that.maxSensorSequences).fill('')); // 用空字符串填充数组

        // 遍历原始数组，将每个binding放入正确的位置
        dataArray.forEach(item => {
          const layer = item.layer_index - 1; // 转换为从0开始的索引
          const sequence = item.sequence_index - 1; // 转换为从0开始的索引
          const binding = item.binding;

          // 将binding放置到正确的位置
          sensorBindings[layer][sequence] = binding;
        });

        // 返回sensorBindings，最大的layerIndex和sequenceIndex
        return {
          sensorBindings: sensorBindings,
          maxLayerIndex: maxLayerIndex,
          maxSequenceIndex: maxSequenceIndex
        };
      }
      that.sensorForm.segment_id = row.segment_id;
      api.post('/querySensorBindings', { segment_id: row.segment_id }).then(response => {
        if (response.data.success) {
          const responseData = response.data.data;
          const transformedData = transformToSensorBindings(responseData);
          that.sensorForm.sensorBindings = transformedData.sensorBindings;
          that.sensorForm.layers = transformedData.maxLayerIndex;
          that.sensorForm.sequences = transformedData.maxSequenceIndex;
          console.log('segmentSensorBindings', response.data.data, transformedData)
        } else {
          this.$message({
            message: '查询传感器时出错',
            type: 'error'
          })
        }
      })
      that.sensorDialogVisible = true;
    },
    saveSegment() {
      const that = this;
      console.log('type', that.form.type)
      if (that.form.type == 'create') {
        that.createSegment();
      } else {
        that.updateSegment();
      }
    },
    updateSensorBindings() {
      const that = this;
      // 修剪尺寸
      function trimSensorBindings(sensorBindings, trimLayer, trimSequence) {
        // 使用数组的 slice 方法来裁剪每个维度
        // 注意：slice 不包括结束索引，所以不需要减1
        return sensorBindings.slice(0, trimLayer).map(layer => layer.slice(0, trimSequence));
      }
      // 验证是否合法
      function validateSensorBindings(sensorBindings) {
        // 定义正则表达式以匹配格式
        const validFormatRegex = that.sensorBindingRegex;

        // 遍历二维数组的所有元素
        for (const layer of sensorBindings) {
          for (const sequence of layer) {
            // 使用正则表达式测试每个元素
            if (!validFormatRegex.test(sequence)) {
              // 如果有任何元素不匹配，则返回false
              return false;
            }
          }
        }
        // 如果所有元素都通过了验证，返回true
        return true;
      }
      // 转换成API用的数据格式
      function transformFromSensorBindings(sensorBindings) {
        const dataArray = [];

        // 遍历sensorBindings的每一层
        sensorBindings.forEach((layerBindings, layerIndex) => {
          // 遍历当前层的每个序列位置
          layerBindings.forEach((binding, sequenceIndex) => {
            // 只对非空字符串创建对象
            if (binding !== '') {
              dataArray.push({
                binding: binding,
                layer_index: layerIndex + 1, // 将索引转换为从1开始的数
                sequence_index: sequenceIndex + 1 // 将索引转换为从1开始的数
              });
            }
          });
        });

        return dataArray;
      }
      const realForm = trimSensorBindings(this.sensorForm.sensorBindings, this.sensorForm.layers, this.sensorForm.sequences);
      const realFormValid = validateSensorBindings(realForm);
      if (realFormValid) {
        const apiData = transformFromSensorBindings(realForm);
        api.post('/updateSensorBindings', { segment_id: that.sensorForm.segment_id, data: apiData }).then(response => {
          if(response.data.success) {
            that.sensorDialogVisible = false;
            that.$message({
              message: '更新成功',
              type:'success'
            })
          } else {
            that.$message({
              message: '更新失败',
              type: 'error'
            })
          }
        })
      } else {
        this.$message({
          message: '存在不合法的值，格式为：设备id-通道号，例如：320004-1',
          type: 'error'
        })
      }
    },
    createSegment() {
      const that = this;
      this.$refs['form'].validate((valid) => {
        if (valid) {
          that.$message('ok')
          api.post('/createSegment', that.form).then(response => {
            const data = response.data;
            if (data.success) {
              that.$message({
                message: '创建成功',
                type: 'success'
              });
              that.$refs['form'].resetFields();
              that.dialogFormVisible = false;
            } else {
              that.$message({
                message: '创建失败',
                type: 'error'
              });
            }
            that.refresh();
          })
        } else {
          return false;
        }
      })
    },
    deleteSegment(segment_id) {
      const that = this;
      api.post('/deleteSegment', {
        segment_id
      }).then(response => {
        if (response.data.success) {
          that.$message({
            message: '删除成功',
            type: 'success'
          });
        } else {
          that.$message({
            message: '删除失败',
            type: 'error'
          });
        }
        that.refresh();
      })
    },
    openBaiduGetPoint() {
      window.open('https://api.map.baidu.com/lbsapi/getpoint/index.html')
    }
  }
}
</script>

<style lang="less" scoped>
#segmentManage {
  padding: 20px;
}

.buttons {
  margin-bottom: 20px;
}

.pagination {
  margin-top: 20px;
}

.avatar {
  width: 100px;
  height: 100px;
}

.avatar-uploader .el-upload {
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  border: 1px dashed #d9d9d9;

}

.tugongdai {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 500px;
}

.layer {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}

.layer-header {
  width: 50px;
  text-align: center;
}

.sequence {
  display: flex;
  height: 100%;
  flex: 1;
  flex-direction: column;
  border: 1px solid black;
  padding: 0;
  align-items: center;
  justify-content: center;
}

.footer .sequence {
  border: none;
}

.sequence-row {
  width: 100%;
  flex: 1;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: row;
}

.sequence-row input {
  background-color: rgba(200, 255, 200, 0.2);
}

.sequence-row.bound input {
  background-color: rgba(200, 255, 200, 0.5);
}

.sequence-row.bound-bad input {
  background-color: rgba(255, 200, 200, 0.5);
}


.sequence-row input {
  flex: 1;
  width: 100%;
  border: 0;
  text-align: center;
}

.sequence-row input::placeholder {
  text-align: center;
}
</style>
